import { render, staticRenderFns } from "./ConfigurationAccounts.vue?vue&type=template&id=177b8a37&"
import script from "./ConfigurationAccounts.vue?vue&type=script&lang=js&"
export * from "./ConfigurationAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports